module.exports = __webpack_public_path__ + "static/media/icon_office.f9e5b4a0.svg";